"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        color: theme.grey4,
        fontWeight: 400,
        position: 'relative',
        paddingTop: 14,
        marginTop: 0,
        marginBottom: 0,
        transition: 'color 100ms linear 0ms',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            backgroundColor: 'currentColor',
            opacity: 0,
            transition: 'opacity 100ms linear 0ms'
        },
        '&[data-is-doing=true]': {
            color: theme.grey2,
            fontWeight: 700,
            '&::before': {
                opacity: 1
            }
        }
    },
    icon: {
        opacity: 0,
        color: theme.validGreen,
        width: 16,
        marginLeft: 7,
        transition: 'opacity 100ms linear 0ms',
        '[data-is-done=true] &': {
            opacity: 1
        }
    },
    label: {
        fontSize: 10,
        lineHeight: 1,
        fontWeight: 600,
        height: 16,
        display: 'flex',
        alignItems: 'center',
        marginBottom: 4,
        color: 'inherit',
        textTransform: 'uppercase',
        letterSpacing: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    title: {
        fontSize: 12,
        lineHeight: 1,
        fontWeight: 'inherit',
        color: 'inherit',
        marginLeft: 0,
        position: 'relative',
        '&::before': {
            content: 'attr(data-text)',
            position: 'absolute',
            left: 0,
            right: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            transition: 'font-weight 100ms linear 0ms'
        }
    },
    titleText: {
        visibility: 'hidden',
        fontWeight: 700,
        overflow: `hidden`,
        whiteSpace: `nowrap`,
        textOverflow: `ellipsis`
    }
});
//# sourceMappingURL=todo.item.style.js.map